import React from 'react';
export function Footer() {
  return <footer className="bg-forest-dark text-gray-400 py-12 border-t border-white/10" data-id="element-101">
      <div className="container mx-auto px-4 text-center" data-id="element-102">
        <p className="text-sm mb-4" data-id="element-103">
          © {new Date().getFullYear()} El Protocolo de los 10 Días. Todos los
          derechos reservados.
        </p>
        <p className="text-xs max-w-2xl mx-auto opacity-60 leading-relaxed" data-id="element-104">
          Descargo de responsabilidad: Este producto no sustituye el consejo
          médico profesional. Consulte a su médico antes de comenzar cualquier
          nuevo régimen de salud o dieta, especialmente si tiene condiciones
          médicas preexistentes.
        </p>
      </div>
    </footer>;
}